import {
	Component,
	SimpleChange,
	SimpleChanges,
	ViewChildren,
	QueryList,
	ChangeDetectionStrategy,
	Input,
	OnChanges,
	Output,
	EventEmitter,
	OnDestroy
} from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, takeUntil, distinctUntilChanged, tap, map } from 'rxjs/operators';
import { AppFilter } from '../../../shared/models/filter';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
// import { SingleSearchFilter } from "./single";
interface IHeaders {
	field?: string;
	label?: string;
	type?: string;
	choices?: any[];
	op?: string;
	data?: any;
}
@Component({
	selector: 'app-search-filter-null',
	templateUrl: './search.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFilter implements OnChanges, OnDestroy {
	@Input() searchName: string = '';
	@Input() headers: any[];
	@Output() submitSearch = new EventEmitter();
	@Output() onCancel = new EventEmitter();

	fieldx: IHeaders[] = [];
	fieldMap = new Map();
	operators = [
		{ id: 'cn', name: 'contains' },
		{ id: 'nc', name: 'does not contain' },
		{ id: 'eq', name: 'equal' },
		{ id: 'ne', name: 'not equal' },
		{ id: 'lt', name: 'less' },
		{ id: 'le', name: 'less or equal' },
		{ id: 'gt', name: 'greater' },
		{ id: 'ge', name: 'greater or equal' },
		{ id: 'bw', name: 'begins with' },
		{ id: 'bn', name: 'does not begin with' },
		{ id: 'ew', name: 'ends with' },
		{ id: 'en', name: 'does not end with' }
	];
	oldoperators = [ { id: 'cn', name: 'contains' }, { id: 'eq', name: 'equal' } ];
	groupOperators = [ { id: 'AND', name: 'AND' }, { id: 'OR', name: 'OR' } ];
	mode = 'date';
	searchFilter = {
		groupOp: 'AND',
		rules: []
	};

	selectForm = new FormControl();

	private unsubscribe$: Subject<void> = new Subject<void>();
	constructor(private fb: FormBuilder) {
		// if (this.headers) {
		//     this.headers.forEach(res => {
		//         this.fieldMap.set(res.id, res)
		//     })
		// }
	}

	ngOnChanges(props: any) {
		// console.log(props)
	}

	changeCondition(value) {
		this.searchFilter.groupOp = value.target.value;
	}

	logSelected(selected) {
		// console.log(selected)
	}
	trackByIndex(index: number, value: any) {
		if (value.type === 'date' && value.data instanceof Date) {
			return value.id;
		} else if (value.type === 'date' && !(value.date instanceof Date)) {
			let d = value.data.split('.')[0];
			value.data = new Date(d);
			return value.id;
		} else {
			return value.id;
		}
	}
	selectedOperator(op, item) {
		// this.fieldMap.set(field.id, field)
	}
	add() {
		if (this.selectForm.value && this.selectForm.value !== '') {
			this.fieldx.push(Object.assign({}, this.selectForm.value));
		}
	}
	remove(index) {
		this.fieldx.splice(index, 1);
	}

	setRule(item) {}

	changeOperators(event) {
		if (event.contractorType === null) {
			this.fieldx[event.index].op = 'eq';
		} else {
			this.fieldx[event.index].op = 'cn';
		}
	}

	submit() {
		let arr = [ ...this.fieldx ];
		let fields = [];
		arr.forEach((item) => {
			if (item.type === 'date' && item.data instanceof Date) {
				item.data = item.data.toISOString().split('.')[0];
				fields.push({ field: item.field, op: item.op, data: item.data });
			} else {
				fields.push({ field: item.field, op: item.op, data: item.data });
			}
		});
		let search = Object.assign({}, this.searchFilter);
		search.rules = fields;
		this.submitSearch.emit(Object.assign({}, search));
	}
	cancel() {
		this.fieldx = [];
		this.onCancel.emit('');
	}

	ngOnDestroy() {}

	ngOnInit() {
		// this.organizationId = window.localStorage.getItem("organizationId")
		// this.messageParams = new AppFilter({ sidx: "messageId", rows: 15 })
		// this.searchMessagesFilter.rules[0].data = this.parentMessageId;
		// this.messageParams.filters = JSON.stringify(this.searchMessagesFilter);
		// this.getMessages(1);
		//   fields.push({ field: item.field, op: item.op, data: item.data })
	}
}
